module.exports = __webpack_public_path__ + "img/rwood.8af50def.jpeg";